import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $transactionStore } from '@lib/store';
import { DateUtils, FormatUtils, AmountUtils, ColorUtils } from '@shared/utils';
import { Table, TableCellType, Text } from '@shared/widgets';

interface ITransactionsTable {
  cardId?: number;
}

export const TransactionsTable = (props: ITransactionsTable) => {
  const transactionStore = useUnit($transactionStore.store);

  const [total, setTotal] = useState<number>(0);
  const [index, setIndex] = useState<number>(1);
  const [count, setCount] = useState<number>(10);
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (transactionStore?.data.data) {
      setTotal(transactionStore?.data.total);
    }
    setLoading(transactionStore?.loading);
  }, [transactionStore?.data.data, transactionStore?.loading]);

  useEffect(() => {
    $transactionStore.events.update({
      FromIndex: (index - 1) * count,
      CardId: props.cardId,
      Count: count,
      ReturnTotalCount: true,
    });
  }, [index, count, location.pathname]);

  return (
    <div className='mb-4'>
      <div className={clsx('flex flex-wrap items-center justify-between', 'mt-5', 'mb-6')}>
        <Text className='pr-4' weight='medium' size='2xl'>
          Transactions
        </Text>
      </div>
      <Table
        columns={['Status', 'Date', 'Description', 'Original amount', 'Amount', 'Card']}
        items={transactionStore?.data.data.map((row) => {
          const color = ColorUtils.getTransactionStatusStyles(row.status);
          return [
            {
              type: TableCellType.Custom,
              value: <div className={clsx('py-1 px-2 text-center font-normal', color.bg, color.text)}>{color.label}</div>,
            },
            {
              type: TableCellType.Text,
              value: DateUtils.formatDate(row.date),
            },
            {
              type: TableCellType.Text,
              value: row.description,
            },
            {
              type: TableCellType.Text,
              value: AmountUtils.transformToAmountWithCurrency(row.amount, row.currency),
            },
            {
              type: TableCellType.Text,
              value: AmountUtils.transformToAmountWithCurrency(row.totalAmount, row.baseCurrency),
            },
            {
              type: TableCellType.Text,
              value: row.cardNumber && FormatUtils.toSliceNumber(row.cardNumber),
            },
          ];
        })}
        pagination={{
          currentPage: index,
          totalItemCount: total,
          countItemPage: count,
          onChangePage: setIndex,
          onChangeCountItemPage: setCount,
        }}
        isScrollable
        isLoading={loading}
      />
    </div>
  );
};
